import { NgModule } from '@angular/core';

import { FieldSharedModule } from 'field-shared/field-shared.module';
import { SharedModule } from 'shared/shared.module';

import { QueryCommonModule } from 'app/query-common/query-common.module';
import { EventFormComponent } from './view/components/event-form/event-form.component';
import {
  EventListSelectComponent
} from './view/components/event-list-select/event-list-select.component';
import { EventListComponent } from './view/components/event-list/event-list.component';
import {
  EventSearchSelectComponent
} from './view/components/event-search-select/event-search-select.component';
import { EventResponseStatusFilterComponent } from './view/components/event-response-status-filter/event-response-status-filter.component';
import { EventResponseTagsComponent } from './view/components/event-response-tags/event-response-tags.component';
import { MonthCalendarComponent } from './view/components/month-calendar/month-calendar.component';
import {
  MultipleEventsComponent
} from './view/components/multiple-events/multiple-events.component';
import { SelectEventsButtonComponent } from './view/components/select-events-button/select-events-button.component';
import { TimeInputComponent } from './view/components/time-input/time-input.component';
import { WeekCalendarComponent } from './view/components/week-calendar/week-calendar.component';
import { AddEventDialog } from './view/dialogs/add-event/add-event.dialog';
import { AddRsvpsDialog } from './view/dialogs/add-rsvps/add-rsvps.dialog';
import { AddTaskDialog } from './view/dialogs/add-task/add-task.dialog';
import { DeleteEventDialog } from './view/dialogs/delete-event/delete-event.dialog';
import { EditEventDialog } from './view/dialogs/edit-event/edit-event.dialog';
import { ExportEventsDialog } from './view/dialogs/export-events/export-events.dialog';
import { ListEventsDialog } from './view/dialogs/list-events/list-events.dialog';
import { SelectEventsDialog } from './view/dialogs/select-events/select-events.dialog';
import { CalendarHeaderComponent } from './view/components/calendar-header/calendar-header.component';
import { CalendarGridComponent } from './view/components/calendar-grid/calendar-grid.component';
import { EventTaskManageBoxComponent } from './view/components/event-task-manage-box/event-task-manage-box.component';
import { AnEventSyncOptionsComponent } from './view/components/an-event-sync-options/an-event-sync-options.component';

const COMPONENTS = [
  CalendarHeaderComponent,
  EventFormComponent,
  EventListComponent,
  EventListSelectComponent,
  EventSearchSelectComponent,
  EventResponseStatusFilterComponent,
  EventResponseTagsComponent,
  MultipleEventsComponent,
  MonthCalendarComponent,
  SelectEventsButtonComponent,
  TimeInputComponent,
  WeekCalendarComponent,
  CalendarGridComponent,
  EventTaskManageBoxComponent,
  AnEventSyncOptionsComponent
];

const DIALOGS = [
  AddEventDialog,
  AddRsvpsDialog,
  AddTaskDialog,
  DeleteEventDialog,
  EditEventDialog,
  ExportEventsDialog,
  ListEventsDialog,
  SelectEventsDialog,
];

@NgModule({
  imports: [
    FieldSharedModule,
    SharedModule,
    QueryCommonModule,
  ],
  declarations: [...COMPONENTS, ...DIALOGS],
  providers: [],
  exports: [...COMPONENTS, ...DIALOGS],
})
export class EventsSharedModule { }
